/*
  auth.js
    Authentication module
*/

import * as types from '@/store/mutation-types'
//import { isContext } from 'vm'
import { loginProc, loginProcByToken, reissueLoginToken } from '@/api'
import { LS_LOGIN_ID, LS_TOKEN_KEY, isNullorUndefined } from '@/common'
import { sLog } from '@/common/simple-logger'

export default {
  state: {
    sLoggedIn: false,
    sStoredLoginId: '',
    sAccessToken: '',
  },
  getters: {
    isLoggedIn: state => state.sLoggedIn,
    storedLoginId: state => state.sStoredLoginId,
    accessToken: state => state.sAccessToken,
  },
  actions: {
    // -------------------------------------------------------------------------
    // login process
    //   return null if login failed
    aLoginProc: async (context, payload) => {
      sLog.debug('@action aLoginProc ' + payload.id)

      let res = await loginProc(payload.id, payload.passwd)
      console.assert(!isNullorUndefined(res), 'login response is null')

      if (!res.error && !res.body.error) {
        // Loginに成功したら、localStorageにIDとtokenを保存
        localStorage.setItem(LS_LOGIN_ID, res.body.body.user_id)
        localStorage.setItem(LS_TOKEN_KEY, res.body.body.token)
      }

      return res
    },
    // -------------------------------------------------------------------------
    // login process by token
    //   return null if login failed
    aLoginProcByToken: async (context) => {
      // 本関数が呼ばれる前には、localStorageをチェックして、storeにlogin id, access tokenが保持されているはず
      //console.assert(!isNullorUndefined(context.state.sStoredLoginId), 'login id is NULL!')
      //console.assert(!isNullorUndefined(context.state.sAccessToken), 'token is NULL!')
      sLog.debug('@action aLoginProc ' + context.state.sStoredLoginId)

      let res = await loginProcByToken(context.state.sStoredLoginId, context.state.sAccessToken)
      console.assert(!isNullorUndefined(res), 'login response is null')

      if (!res.error) {
        // Loginに成功したら、localStorageにtokenのみ保存
        localStorage.setItem(LS_TOKEN_KEY, res.body.body.token)
      }
      else {
        // ログインに失敗したら、localStorageからデータを削除
        if (res.status !== 'NoResponse') {
          localStorage.removeItem(LS_LOGIN_ID)
          localStorage.removeItem(LS_TOKEN_KEY)
        }
      }

      return res
    },
    // -------------------------------------------------------------------------
    aChangeLoginStatus: ({ commit }, payload) => {
      sLog.debug('@action aChangeLoginStatus ' + payload)
      commit(types.CHANGE_LOGIN_STATUS, payload)
    },
    // -------------------------------------------------------------------------
    // reissue login token
    //   return null if login failed
    aReissueLoginToken: async (context, payload) => {
      // 本関数が呼ばれる前には、localStorageをチェックして、storeにlogin id, access tokenが保持されているはず
      const userId = localStorage.getItem(LS_LOGIN_ID)
      const token = localStorage.getItem(LS_TOKEN_KEY)
      sLog.debug('@action aReissueLoginToken ' + userId)

      let res = await reissueLoginToken(userId, token)
      if (!res.error) {
        // 再発行に成功したら、localStorageにtokenを保存
        localStorage.setItem(LS_TOKEN_KEY, res.body.body)
      }
      else {
        // 失敗したら、localStorageからデータを削除
        if (res.status !== 'NoResponse') {
          localStorage.removeItem(LS_LOGIN_ID)
          localStorage.removeItem(LS_TOKEN_KEY)
        }
      }
      return res
    },
  },
  mutations: {
    // -------------------------------------------------------------------------
    // check login storage
    //    同期処理で実行したいため、mutationsで定義する
    checkLoginStorage: (state) => {
      state.sStoredLoginId = localStorage.getItem(LS_LOGIN_ID)
      sLog.debug('@store storage login id : ' + localStorage.getItem(LS_LOGIN_ID))
      state.sAccessToken = localStorage.getItem(LS_TOKEN_KEY)
      sLog.debug('@store storage token : ' + localStorage.getItem(LS_TOKEN_KEY))
    },
    // -------------------------------------------------------------------------
    // user logged in
    [types.CHANGE_LOGIN_STATUS] (state, loginStatus) {
      // ログアウトの場合は、storeとlocalStorageをクリアする
      if (loginStatus === false) {
        state.sStoredLoginId = ''
        state.sAccessToken = ''
        //localStorage.removeItem(LS_LOGIN_ID)
        //localStorage.removeItem(LS_TOKEN_KEY)
        localStorage.clear()
      }
      state.sLoggedIn = loginStatus
      sLog.debug('@store login status changed : ' + state.sLoggedIn)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js